import * as React from 'react';
import { Row, Col, Alert } from 'react-bootstrap';
import { reduxForm, formValueSelector, InjectedFormProps } from 'redux-form';
import LoginForm from './components/LoginForm';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import {
  actions as authActions,
  IAuthActions,
} from '../../../../services/auth/reducer';
import FaSpinner from 'react-icons/fa/spinner';
import * as moment from 'moment';
import { IAuthState } from '../../../../services/auth/models';
import Helmet from 'react-helmet';

interface ILoginProps extends InjectedFormProps {
  auth: IAuthState;
  actions: {
    push: (route: string) => void;
    auth: IAuthActions;
  };
  loginFailed: boolean;
}

class Login extends React.Component<ILoginProps> {
  private handleSubmit = (formValues) => {
    const { actions } = this.props;
    const dob = moment(formValues.dob, 'DD/MM/YYYY').format('YYYY-MM-DD');

    return actions.auth
      .login(formValues.email, formValues.password, dob)
      .then(() => {
        actions.push('/account/summary');
      });
  }

  public render() {
    const { loginFailed, auth } = this.props;
    return (
      <Row className="page-container" style={{ marginTop: '10px' }}>
        <Helmet>
          <title>Login</title>
        </Helmet>
        <Col xs={12}>
          {!auth.hasPasswordBeenReset ? (
            <div className="customer-section-title">
              <h1>Log In</h1>
              <p>If you are an existing customer, please log in below to view your quotes and policies.</p>
              {loginFailed && (
                <Alert className="login-failure">
                  Your email address, password or date of birth doesn't match
                  our records - please try again.
                </Alert>
              )}
              <LoginForm onSubmit={this.handleSubmit} />
            </div>
          ) : (
            <div className="log-in redirect">
              <FaSpinner className="fa-spin spin-icon" />
              <span> You are now being redirected...</span>
            </div>
          )}
        </Col>
      </Row>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'login',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state) => {
      const tripType = selector(state, 'tripType');
      return {
        tripType,
        loginFailed: state.auth.loginFailed,
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        auth: bindActionCreators(authActions, dispatch),
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(Login);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/Login/index.tsx